(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: window.MDMTheme?.currency || 'EUR' });
  const formatPrice = cents => money.format(cents / 100);
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const catalog = Object.assign(Object.create(null), {
    solo: { name: 'Pure Tahara', detail: 'Musc seul · 15 ml', price: 2999, stock: 52, image: 'tahara-packshot-v6.jpg' },
    duo: { name: 'Le duo Pure Tahara', detail: 'Musc 15 ml + crème corporelle', price: 5599, stock: 49, image: window.MDM_PRODUCT_CATALOG?.['51615092310359']?.image || 'mdm-tahara-duo.jpg' }
  });
  const validCatalogKey = key => typeof key === 'string' && /^[a-zA-Z0-9_-]+$/.test(key) && !['__proto__', 'prototype', 'constructor'].includes(key);
  const externalCatalog = window.MDM_PRODUCT_CATALOG;
  if (externalCatalog && typeof externalCatalog === 'object' && !Array.isArray(externalCatalog)) {
    Object.entries(externalCatalog).forEach(([key, product]) => {
      if (!validCatalogKey(key) || Object.hasOwn(catalog, key) || !product || typeof product !== 'object') return;
      if (typeof product.name !== 'string' || !Number.isSafeInteger(product.price) || product.price < 0 || !Number.isSafeInteger(product.stock) || product.stock < 0) return;
      catalog[key] = { name: product.name, detail: String(product.detail || ''), price: product.price, stock: product.stock, image: String(product.image || 'tahara-packshot-v6.jpg'), productUrl: String(product.productUrl || '') };
    });
  }
  [['solo', '50158407876951'], ['duo', '51615092310359']].forEach(([alias, id]) => {
    if (Object.hasOwn(catalog, id)) {
      catalog[alias].price = catalog[id].price;
      catalog[alias].stock = catalog[id].stock;
    }
  });
  const hasProduct = key => validCatalogKey(key) && Object.hasOwn(catalog, key);
  const canonicalProductKey = key => ({ '50158407876951': 'solo', '51615092310359': 'duo' })[String(key)] || String(key);
  const escapeHTML = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const imageURL = value => {
    const path = String(value || '').trim();
    const hosted = window.MDMTheme?.assets?.[path.replace(/^assets\//, '')];
    if (hosted) return hosted;
    if (/^https:\/\//i.test(path) || /^(?:\.?\.?\/)?assets\//.test(path) || path.startsWith('/')) return path;
    return `assets/${path}`;
  };
  const cartIcon = name => `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${{
    bag: '<path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 7V5a4 4 0 0 1 8 0v2"/>',
    truck: '<path d="M3 5h11v11H3zM14 9h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
    lock: '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V6a4 4 0 0 1 8 0v4M12 14v3"/>',
    check: '<path d="m6 12 4 4 8-8"/>',
    chat: '<path d="M20 11a8 8 0 0 1-8 8H5l-3 3V11a9 9 0 0 1 18 0Z"/><path d="M7 9h8M7 13h5"/>'
  }[name] || ''}</svg>`;
  const basket = new Map();
  const cartStorageKey = 'mirage-de-musc:preview-cart:v1';
  const cartStorageVersion = 1;
  const activeAnimations = new Set();
  const feedbackAnimations = new WeakMap();
  const pictureAnimations = new WeakMap();
  const pictureRequests = new WeakMap();
  const cartDialog = $('.cart-dialog');
  const zoomDialog = $('.zoom-dialog');
  const mainPhoto = $('#main-photo');
  const sticky = $('.sticky-buy');
  let selectedOffer = 'solo';
  let toastTimer;
  let restoreFocus = null;
  let previousCartTotal = 0;
  let paymentCloneSequence = 0;

  function makeConfiguredProduct(baseKey, rawProperties) {
    baseKey = canonicalProductKey(baseKey);
    if (!hasProduct(baseKey) || !rawProperties || typeof rawProperties !== 'object' || Array.isArray(rawProperties)) return null;
    const entries = Object.entries(rawProperties).sort(([a], [b]) => a.localeCompare(b));
    if (!entries.length || entries.length > 20 || entries.some(([key, value]) => !key.trim() || key.length > 100 || typeof value !== 'string' || !value.trim() || value.length > 2000)) return null;
    const properties = Object.fromEntries(entries);
    const signature = JSON.stringify(properties);
    let hash = 2166136261;
    for (let index = 0; index < signature.length; index++) hash = Math.imul(hash ^ signature.charCodeAt(index), 16777619);
    const stem = `cfg_${baseKey}_${(hash >>> 0).toString(16)}`;
    let key = stem;
    let suffix = 0;
    while (hasProduct(key) && JSON.stringify(catalog[key].properties) !== signature) key = `${stem}_${++suffix}`;
    if (!hasProduct(key)) catalog[key] = { ...catalog[baseKey], baseId: baseKey, properties };
    return key;
  }

  function baseProductKey(key) { return catalog[key]?.baseId || key; }

  function quantityForBase(baseKey, exceptKey = null) {
    let total = 0;
    basket.forEach((quantity, key) => { if (key !== exceptKey && baseProductKey(key) === baseKey) total += quantity; });
    return total;
  }

  function maximumForLine(key) {
    return Math.max(1, catalog[key].stock - quantityForBase(baseProductKey(key), key));
  }

  function paymentBadges() {
    const source = $$('.mdm-payments').find(element => !element.closest('.cart-dialog'));
    if (!source) return '';
    const clone = source.cloneNode(true);
    clone.classList.add('cart-payment-badges');
    const idMap = new Map();
    const prefix = `cart-payment-${++paymentCloneSequence}-`;
    $$('[id]', clone).forEach((element, index) => {
      idMap.set(element.id, `${prefix}${index}`);
      element.id = `${prefix}${index}`;
    });
    $$('*', clone).forEach(element => {
      [...element.attributes].forEach(attribute => {
        let value = attribute.value;
        idMap.forEach((replacement, original) => {
          value = value.split(`url(#${original})`).join(`url(#${replacement})`);
          if (value === `#${original}`) value = `#${replacement}`;
          if (['aria-labelledby', 'aria-describedby'].includes(attribute.name)) value = value.split(' ').map(token => token === original ? replacement : token).join(' ');
        });
        if (value !== attribute.value) element.setAttribute(attribute.name, value);
      });
    });
    return clone.outerHTML;
  }

  function toast(message) {
    const element = $('.toast');
    if (!element) return;
    clearTimeout(toastTimer);
    element.textContent = message;
    element.hidden = false;
    toastTimer = setTimeout(() => { element.hidden = true; }, 5200);
  }

  function boundedQuantity(value, maximum) {
    const number = Number(value);
    return Number.isFinite(number) ? Math.min(maximum, Math.max(1, Math.trunc(number))) : 1;
  }

  function restoreCart() {
    const restored = new Map();
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(cartStorageKey));
      if (saved?.version === cartStorageVersion && Array.isArray(saved.items)) {
        saved.items.forEach(item => {
          if (!item || typeof item.id !== 'string') return;
          const key = item.baseId ? makeConfiguredProduct(item.baseId, item.properties) : canonicalProductKey(item.id);
          if (!hasProduct(key) || catalog[key].stock < 1 || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return;
          const base = baseProductKey(key);
          let reserved = 0;
          restored.forEach((quantity, restoredKey) => { if (baseProductKey(restoredKey) === base) reserved += quantity; });
          const remaining = Math.max(0, catalog[key].stock - reserved);
          if (remaining > 0) restored.set(key, (restored.get(key) || 0) + Math.min(item.quantity, remaining));
        });
      }
    } catch {
      // A blocked storage area or an invalid record must never prevent the demo.
      return;
    }
    basket.clear();
    restored.forEach((quantity, id) => basket.set(id, quantity));
  }

  function saveCart() {
    try {
      const items = [...basket].map(([id, quantity]) => catalog[id].baseId ? { id, quantity, baseId: catalog[id].baseId, properties: catalog[id].properties } : { id, quantity });
      window.sessionStorage.setItem(cartStorageKey, JSON.stringify({ version: cartStorageVersion, items }));
    } catch {
      // The current page keeps working in memory when storage is unavailable.
    }
  }

  function playAnimation(element, frames, options) {
    if (motion.matches || typeof element?.animate !== 'function') return null;
    const animation = element.animate(frames, options);
    activeAnimations.add(animation);
    const release = () => activeAnimations.delete(animation);
    animation.addEventListener('finish', release, { once: true });
    animation.addEventListener('cancel', release, { once: true });
    return animation;
  }

  function animateFeedback(element, frames, options) {
    if (!element) return;
    feedbackAnimations.get(element)?.cancel();
    const animation = playAnimation(element, frames, options);
    if (animation) feedbackAnimations.set(element, animation);
  }

  function animatePurchaseButton(button) {
    animateFeedback(button, [
      { transform: 'scale(1)' },
      { transform: 'scale(.975)', offset: 0.3 },
      { transform: 'scale(1)' }
    ], { duration: 250, easing: 'ease-out' });
  }

  function animateGalleryCaption() {
    $$('#gallery-kicker, #gallery-title, #gallery-description').forEach((element, index) => {
      animateFeedback(element, [
        { opacity: 0.65, transform: 'translateY(6px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 310, delay: index * 35, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards' });
    });
  }

  function animatePicture(picture, onReady) {
    if (!picture) return;
    pictureAnimations.get(picture)?.cancel();
    const request = Symbol('picture');
    pictureRequests.set(picture, request);
    if (motion.matches) return;
    const fade = () => {
      if (pictureRequests.get(picture) !== request || !picture.naturalWidth) return;
      const animation = playAnimation(picture, [
        { opacity: 0.68, transform: 'translateX(8px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 340, easing: 'cubic-bezier(.2,.65,.3,1)' });
      if (animation) pictureAnimations.set(picture, animation);
      if (!motion.matches) onReady?.();
    };
    if (picture.complete) fade();
    else if (typeof picture.decode === 'function') picture.decode().then(fade).catch(() => {});
    else picture.addEventListener('load', fade, { once: true });
  }

  function updateGalleryDetails(filename) {
    const thumbnails = $$('.thumb');
    const selected = thumbnails.find(button => imageURL(button.dataset.photo) === imageURL(filename));
    thumbnails.forEach(button => {
      button.setAttribute('aria-pressed', String(button === selected));
    });
    const strip = selected?.parentElement;
    if (strip?.classList.contains('thumbs') && strip.scrollWidth > strip.clientWidth) {
      const left = selected.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft - (strip.clientWidth - selected.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: motion.matches ? 'auto' : 'smooth' });
    }
    const counter = $('.gallery-count');
    if (counter) counter.textContent = selected ? `${String(thumbnails.indexOf(selected) + 1).padStart(2, '0')} / ${String(thumbnails.length).padStart(2, '0')}` : 'LE DUO';
    [['#gallery-kicker', 'kicker'], ['#gallery-title', 'title'], ['#gallery-description', 'description']].forEach(([selector, field]) => {
      const element = $(selector);
      if (element) element.textContent = selected?.dataset[field] || '';
    });
  }

  function setMainPhoto(filename, alt) {
    if (!mainPhoto) return;
    const source = imageURL(filename);
    const changed = mainPhoto.getAttribute('src') !== source;
    if (changed) mainPhoto.src = source;
    mainPhoto.alt = alt;
    updateGalleryDetails(filename);
    if (changed) animatePicture(mainPhoto, animateGalleryCaption);
  }

  function stepGallery(direction) {
    const thumbnails = $$('.thumb');
    if (!thumbnails.length) return;
    const current = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    const next = thumbnails[(current + direction + thumbnails.length) % thumbnails.length];
    setMainPhoto(next.dataset.photo, next.dataset.alt || $('img', next)?.alt || 'Pure Tahara');
  }

  const galleryStage = $('.gallery-stage');
  let galleryGesture = null;
  if (galleryStage) {
    galleryStage.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch' || !event.isPrimary) {
        galleryGesture = null;
        return;
      }
      if (event.target.closest('button, a, input, select, textarea, [role="button"]')) {
        galleryGesture = null;
        return;
      }
      galleryGesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }, { passive: true });
    galleryStage.addEventListener('pointerup', event => {
      if (!galleryGesture || event.pointerId !== galleryGesture.id) return;
      const horizontal = event.clientX - galleryGesture.x;
      const vertical = event.clientY - galleryGesture.y;
      galleryGesture = null;
      if (Math.abs(horizontal) >= 40 && Math.abs(horizontal) > Math.abs(vertical) * 1.3) {
        stepGallery(horizontal < 0 ? 1 : -1);
      }
    }, { passive: true });
    const cancelGalleryGesture = () => { galleryGesture = null; };
    galleryStage.addEventListener('pointercancel', cancelGalleryGesture, { passive: true });
    galleryStage.addEventListener('lostpointercapture', cancelGalleryGesture, { passive: true });
  }

  function chooseOffer(value) {
    if (!hasProduct(value)) return;
    selectedOffer = value;
    $$('.offer').forEach(offer => {
      const input = $('input[name="offer"]', offer);
      if (input) {
        input.checked = input.value === value;
        offer.classList.toggle('selected', input.checked);
      }
    });
    const product = catalog[value];
    const nativeVariant = document.querySelector('#mdm-pure-variant');
    if (nativeVariant) nativeVariant.value = window.MDMTheme?.aliases?.[value] || '';
    const nativeAdd = document.querySelector('#add-product');
    if (nativeAdd) nativeAdd.disabled = !product || product.stock < 1;
    if ($('#product-price')) $('#product-price').textContent = formatPrice(product.price);
    if ($('#sticky-price')) $('#sticky-price').textContent = `${value === 'duo' ? 'Musc + crème' : '15 ml'} · ${formatPrice(product.price)}`;
    if (sticky) sticky.firstElementChild.firstChild.textContent = value === 'duo' ? 'Le duo Pure Tahara' : 'Pure Tahara';
    setMainPhoto(product.image, value === 'duo' ? 'Le musc Pure Tahara avec sa crème corporelle assortie' : 'Pure Tahara, flacon de 15 ml et étui');
  }

  function openDialog(dialog, focusTarget) {
    if (!dialog || dialog.open) return;
    restoreFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('modal-open');
    (focusTarget || $('button', dialog))?.focus();
    if (dialog === cartDialog) {
      animateFeedback(dialog, [
        { opacity: 0.7, transform: 'translateX(48px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 380, easing: 'cubic-bezier(.2,.75,.25,1)' });
    }
  }

  function closeDialog(dialog) {
    if (dialog?.open) dialog.close();
  }

  [cartDialog, zoomDialog].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
      if (restoreFocus?.isConnected) restoreFocus.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(dialog);
    });
  });
  if (zoomDialog) zoomDialog.setAttribute('aria-label', 'Photo du produit agrandie');

  function cartTotals() {
    const entries = [...basket.entries()];
    const count = entries.reduce((sum, [, quantity]) => sum + quantity, 0);
    const total = entries.reduce((sum, [key, quantity]) => sum + catalog[key].price * quantity, 0);
    return { entries, count, total };
  }

  function updateCartCount(count) {
    $$('.cart-count, .cart-title-count').forEach(element => {
      const changed = element.textContent !== String(count);
      element.textContent = String(count);
      if (changed) animateFeedback(element, [
        { transform: 'scale(1)' },
        { transform: 'scale(1.2)', offset: 0.35 },
        { transform: 'scale(1)' }
      ], { duration: 340, easing: 'ease-out' });
    });
    $$('.cart-open').forEach(button => button.setAttribute('aria-label', `Ouvrir le panier de démonstration, ${count} article${count === 1 ? '' : 's'}`));
  }

  function shippingMessage(total) {
    return total >= 5000 ? 'Votre livraison est offerte.' : `Encore ${formatPrice(5000 - total)} pour la livraison offerte.`;
  }

  function shippingPanel(total) {
    const progress = Math.min(100, total / 5000 * 100);
    return `<div class="cart-shipping${total >= 5000 ? ' is-earned' : ''}">
      <div class="cart-shipping-heading"><span class="cart-shipping-icon">${cartIcon(total >= 5000 ? 'check' : 'truck')}</span><p class="cart-shipping-message" role="status" aria-live="polite">${shippingMessage(total)}</p></div>
      <div class="shipping-track" role="progressbar" aria-label="Progression vers la livraison offerte" aria-valuemin="0" aria-valuemax="5000" aria-valuenow="${Math.min(5000, total)}" aria-valuetext="${escapeHTML(shippingMessage(total))}"><span style="width:${progress}%"></span></div>
      <div class="cart-shipping-scale"><span>0 €</span><span>50 € · Livraison offerte</span></div>
      <a class="cart-shipping-conditions" href="livraison.html">Avec Colissimo, Chronopost & Mondial Relay · Voir les conditions</a>
    </div>`;
  }

  function updateShipping(total) {
    const panel = $('.cart-shipping', cartDialog);
    if (!panel) return;
    panel.classList.toggle('is-earned', total >= 5000);
    $('.cart-shipping-message', panel).textContent = shippingMessage(total);
    $('.cart-shipping-icon', panel).innerHTML = cartIcon(total >= 5000 ? 'check' : 'truck');
    const track = $('.shipping-track', panel);
    track.setAttribute('aria-valuenow', String(Math.min(5000, total)));
    track.setAttribute('aria-valuetext', shippingMessage(total));
    $('span', track).style.width = `${Math.min(100, total / 5000 * 100)}%`;
    const shippingCost = $('.cart-shipping-cost', cartDialog);
    if (shippingCost) shippingCost.textContent = total >= 5000 ? 'Offerte*' : 'Calculée à l’étape suivante';
    previousCartTotal = total;
  }

  function renderCart() {
    const content = $('#cart-content');
    if (!content) return;
    const { entries, count, total } = cartTotals();
    updateCartCount(count);
    const heading = $('#cart-title');
    if (heading) heading.innerHTML = `Votre panier <span class="cart-title-count">${count}</span>`;
    if (!entries.length) {
      content.innerHTML = `${shippingPanel(0)}<div class="cart-empty-state"><span class="cart-empty-icon">${cartIcon('bag')}</span><h3>Une jolie découverte<br>vous attend.</h3><p>Votre panier est encore vide.<br>Trouvez la senteur qui vous ressemble.</p><a class="cta cart-empty-link" href="catalogue.html">Découvrir les senteurs</a></div><div class="cart-empty-help">${cartIcon('chat')}<p>Un doute sur le parfum à choisir ?<br><a href="contact.html">Nous sommes là pour vous aider</a></p></div>`;
      previousCartTotal = 0;
      return;
    }
    const lines = entries.map(([key, quantity]) => {
      const product = catalog[key];
      const name = escapeHTML(product.name);
      const maximum = maximumForLine(key);
      const configured = product.properties ? `<p class="cart-customization">${Object.entries(product.properties).map(([label, value]) => `${escapeHTML(label === 'Products' ? 'Vos 4 muscs' : label)} : ${escapeHTML(value)}`).join('<br>')}</p>` : '';
      return `<article class="cart-line" data-cart-line="${key}">
        <img src="${escapeHTML(imageURL(product.image))}" alt="${name}" width="96" height="96">
        <div class="cart-line-info">
          <div class="cart-line-heading"><h3>${name}</h3><strong class="cart-line-price">${formatPrice(product.price * quantity)}</strong></div>
          <p>${escapeHTML(product.detail)}</p>${configured}<small>${formatPrice(product.price)} l’unité</small>
          <div class="cart-line-actions"><div class="cart-quantity">
            <button type="button" data-cart-step="-1" data-cart-key="${key}" aria-label="Diminuer la quantité de ${name}" ${quantity === 1 ? 'disabled' : ''}>−</button>
            <input type="number" value="${quantity}" min="1" max="${maximum}" inputmode="numeric" data-cart-input="${key}" aria-label="Quantité de ${name}">
            <button type="button" data-cart-step="1" data-cart-key="${key}" aria-label="Augmenter la quantité de ${name}" ${quantity >= maximum ? 'disabled' : ''}>+</button>
          </div><button type="button" class="cart-remove" data-cart-remove="${key}" aria-label="Retirer ${name} du panier">Retirer</button></div>
        </div>
      </article>`;
    }).join('');
    content.innerHTML = `${shippingPanel(total)}<div class="cart-lines">${lines}</div><div class="cart-summary">
      <div class="cart-total"><span>Sous-total</span><strong>${formatPrice(total)}</strong></div>
      <div class="cart-delivery-row"><span>Livraison</span><span class="cart-shipping-cost">${total >= 5000 ? 'Offerte*' : 'Calculée à l’étape suivante'}</span></div>
      <button type="button" class="cta cart-checkout" data-cart-checkout>${cartIcon('lock')}<span>Continuer vers le paiement</span><span aria-hidden="true">→</span></button>
      <div class="cart-payment-caption">Paiement sécurisé · Vos moyens de paiement habituels</div>
      ${paymentBadges()}
      <div class="cart-reassurance"><a href="livraison.html">${cartIcon('truck')}<span>Suivi de livraison</span></a><a href="contact.html">${cartIcon('chat')}<span>Une question ? Écrivez-nous</span></a></div>
      <p class="cart-demo-checkout">Aperçu interactif · Le paiement sera disponible sur la boutique.</p>
    </div>`;
    const start = Math.min(100, previousCartTotal / 5000 * 100);
    const end = Math.min(100, total / 5000 * 100);
    if (start !== end) playAnimation($('.shipping-track span', content), [{ width: `${start}%` }, { width: `${end}%` }], { duration: 550, easing: 'cubic-bezier(.2,.65,.3,1)' });
    previousCartTotal = total;
  }

  function addProduct(key, requestedQuantity = 1) {
    return addProducts([{ id: key, quantity: requestedQuantity }]);
  }

  function addProducts(items) {
    if (!Array.isArray(items) || !items.length || items.length > 50) return false;
    const requested = new Map();
    for (const item of items) {
      if (!item || !['string', 'number'].includes(typeof item.id)) return false;
      const key = canonicalProductKey(item.id);
      if (!hasProduct(key)) return false;
      if (key === '49387618533719') { toast('Choisissez d’abord les quatre senteurs de votre coffret.'); return false; }
      if (catalog[key].stock < 1) { toast('Une senteur de votre sélection est momentanément indisponible.'); return false; }
      const quantity = Number(item.quantity ?? 1);
      const combined = quantity + (requested.get(key) || 0);
      if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(combined)) {
        toast('Choisissez une quantité entière d’au moins un article.');
        return false;
      }
      requested.set(key, combined);
    }
    const requestedByBase = new Map();
    requested.forEach((quantity, key) => { const base = baseProductKey(key); requestedByBase.set(base, quantity + (requestedByBase.get(base) || 0)); });
    for (const [key, quantity] of requestedByBase) {
      const remaining = catalog[key].stock - quantityForBase(key);
      if (quantity > remaining) {
        toast(remaining > 0
          ? `Il reste ${remaining} article${remaining > 1 ? 's' : ''} de ${catalog[key].name} à ajouter. Votre sélection n’a pas été ajoutée.`
          : `La quantité disponible de ${catalog[key].name} est déjà dans votre panier. Votre sélection n’a pas été ajoutée.`);
        return false;
      }
    }
    requested.forEach((quantity, key) => {
      basket.set(key, (basket.get(key) || 0) + quantity);
    });
    saveCart();
    renderCart();
    openDialog(cartDialog, $('.cart-close'));
    return true;
  }

  function changeCartQuantity(key, value, focusSelector) {
    if (!basket.has(key) || !hasProduct(key)) return;
    basket.set(key, boundedQuantity(value, maximumForLine(key)));
    saveCart();
    renderCart();
    const preferred = focusSelector && $(focusSelector, cartDialog);
    if (preferred && !preferred.disabled) preferred.focus({ preventScroll: true });
    else $(`[data-cart-input="${key}"]`, cartDialog)?.focus({ preventScroll: true });
  }

  function commitTypedCartQuantity(input, normalize = false) {
    const key = input.dataset.cartInput;
    if (!basket.has(key) || !Object.hasOwn(catalog, key)) return;
    const value = input.valueAsNumber;
    // Preserve an unfinished edit (for example an empty field) until blur.
    if (!normalize && (!Number.isSafeInteger(value) || value < 1)) return;
    const quantity = boundedQuantity(value, maximumForLine(key));
    if (normalize || quantity !== value) input.value = String(quantity);
    basket.set(key, quantity);
    saveCart();

    // Keep the focused input in the DOM so multi-digit typing and Tab stay natural.
    const { count, total } = cartTotals();
    updateCartCount(count);
    const line = input.closest('.cart-line');
    $('.cart-line-price', line).textContent = formatPrice(catalog[key].price * quantity);
    $('[data-cart-step="-1"]', line).disabled = quantity <= 1;
    $$('[data-cart-input]', cartDialog).forEach(field => {
      const currentKey = field.dataset.cartInput;
      const maximum = maximumForLine(currentKey);
      field.max = String(maximum);
      $('[data-cart-step="1"]', field.closest('.cart-line')).disabled = (basket.get(currentKey) || 1) >= maximum;
    });
    $('.cart-total strong', cartDialog).textContent = formatPrice(total);
    updateShipping(total);
  }

  const senses = {
    scent: { heading: 'Le souvenir du linge frais.', text: 'Des notes de coton frais et de propre, enveloppées dans la douceur du musc. Une signature réconfortante pour celles et ceux qui aiment les senteurs cotonneuses.' },
    texture: { heading: 'Une douceur à fleur de peau.', text: 'Une texture crémeuse et non collante, au toucher velouté. Le plaisir de retrouver votre parfum dans une texture douce.' },
    format: { heading: 'Petit format, belle attention.', text: 'Un flacon airless de 15 ml, présenté dans son étui Mirage de Musc. Sa pompe permet de doser le produit, et son format compact se glisse facilement dans le quotidien.' }
  };
  const scentFinder = {
    pure: { name: 'Pure Tahara', image: 'mdm-tahara-scene.jpg', label: 'COTON FRAIS · MUSC BLANC', description: 'Le souvenir du linge frais, enveloppé dans la douceur du musc.', link: 'pure-tahara.html' },
    cherry: { name: 'Cherry Prestige', image: 'cherry-packshot-v6.jpg', label: 'CERISE · FRUITÉ & GOURMAND', description: 'Les notes de cerise de Cherry Prestige, pour celles et ceux qui aiment les senteurs fruitées et gourmandes.', link: '/products/musc-intime-cherry-prestige-15-ml' },
    soleil: { name: 'Soleil Blanc', image: 'soleil-packshot-v6.jpg', label: 'MONOÏ · SOLAIRE & FLEURI', description: 'L’univers solaire du monoï. Soleil Blanc évoque l’été dans une senteur fleurie à faire vôtre.', link: '/products/musc-intime-soleil-blanc-15-ml' }
  };

  function activateTab(button) {
    const tablist = button.closest('[role="tablist"]');
    if (!tablist) return;
    $$('[role="tab"]', tablist).forEach(tab => {
      tab.setAttribute('aria-selected', String(tab === button));
      tab.tabIndex = tab === button ? 0 : -1;
    });
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    panel.setAttribute('aria-labelledby', button.id);
    if (button.dataset.sense && senses[button.dataset.sense]) {
      const content = senses[button.dataset.sense];
      $('h3', panel).textContent = content.heading;
      $('p', panel).textContent = content.text;
    }
    if (button.dataset.find && scentFinder[button.dataset.find]) {
      const content = scentFinder[button.dataset.find];
      const picture = $('img', panel);
      picture.src = imageURL(content.image);
      picture.alt = content.name;
      $('.eyebrow', panel).textContent = content.label;
      $('h3', panel).textContent = content.name;
      $('p', panel).textContent = content.description;
      const link = $('a', panel);
      link.href = (window.MDMTheme?.productLinks?.[button.dataset.find] || content.link);
      link.toggleAttribute('data-preview', content.link === '#');
      const found = (window.MDM_PRODUCTS || []).find(item => item.url === link.getAttribute('href'));
      link.textContent = `Découvrir · ${formatPrice(found?.variants?.[0]?.price ?? 2999)}`;
      animatePicture(picture);
    }
  }
  $$('.scent-options').forEach(tablist => tablist.setAttribute('aria-orientation', 'vertical'));
  $$('[role="tabpanel"]').forEach(panel => { panel.tabIndex = 0; });

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const preview = target.closest('[data-preview]');
    if (preview) {
      event.preventDefault();
      toast('Cette page sera reliée à la boutique lors de l’installation. Vous êtes dans l’aperçu du design.');
      return;
    }
    const thumb = target.closest('.thumb');
    if (thumb) setMainPhoto(thumb.dataset.photo, thumb.dataset.alt || $('img', thumb)?.alt || 'Pure Tahara');
    if (target.closest('.gallery-prev')) stepGallery(-1);
    if (target.closest('.gallery-next')) stepGallery(1);
    const tab = target.closest('[role="tab"]');
    if (tab) activateTab(tab);
    const addButton = target.closest('#add-product, [data-sticky-add]');
    if (false && addButton) {
      animatePurchaseButton(addButton);
      addProduct(selectedOffer, 1);
    }
    const duoButton = target.closest('[data-add-duo]');
    if (false && duoButton) {
      animatePurchaseButton(duoButton);
      addProduct('duo');
    }
    if (false && target.closest('.cart-open')) { renderCart(); openDialog(cartDialog, $('.cart-close')); }
    if (target.closest('.cart-close, .continue-shopping')) closeDialog(cartDialog);
    if (target.closest('[data-cart-checkout]')) toast('Vous êtes dans l’aperçu du site : aucune commande ni aucun paiement ne sont effectués.');
    if (target.closest('.zoom-open') && zoomDialog && mainPhoto) {
      const picture = $('img', zoomDialog);
      picture.src = mainPhoto.src;
      picture.alt = mainPhoto.alt;
      openDialog(zoomDialog, $('.zoom-close'));
    }
    if (target.closest('.zoom-close')) closeDialog(zoomDialog);
    const step = target.closest('[data-cart-step]');
    if (step) {
      const key = step.dataset.cartKey;
      changeCartQuantity(key, (basket.get(key) || 1) + Number(step.dataset.cartStep), `[data-cart-step="${step.dataset.cartStep}"][data-cart-key="${key}"]`);
    }
    const remove = target.closest('[data-cart-remove]');
    if (remove) {
      const key = remove.dataset.cartRemove;
      if (!hasProduct(key) || !basket.has(key)) return;
      basket.delete(key);
      saveCart();
      renderCart();
      ($('.cart-remove', cartDialog) || $('.continue-shopping'))?.focus({ preventScroll: true });
      toast(`${catalog[key].name} a été retiré du panier de démonstration.`);
    }
    if (target.closest('.menu nav a')) $$('.menu[open]').forEach(menu => { menu.open = false; });
  });

  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name === 'offer') chooseOffer(input.value);
    if (input.dataset.cartInput) commitTypedCartQuantity(input, true);
  });

  document.addEventListener('input', event => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.dataset.cartInput) commitTypedCartQuantity(input);
  });



  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element)) return;
    if (event.key === 'Escape') {
      $$('.menu[open]').forEach(menu => { menu.open = false; $('summary', menu)?.focus(); });
      $('.toast').hidden = true;
    }
    const tab = event.target.closest('[role="tab"]');
    const thumb = event.target.closest('.thumb');
    if (!tab && !thumb) return;
    const controls = tab ? $$('[role="tab"]', tab.closest('[role="tablist"]')) : $$('.thumb');
    const selected = tab || thumb;
    const index = controls.indexOf(selected);
    const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (!keys.includes(event.key)) return;
    event.preventDefault();
    let next = index;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = controls.length - 1;
    else next = (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + controls.length) % controls.length;
    controls[next].focus();
    controls[next].click();
  });

  const buyRow = $('.buy-row');
  const progress = $('.scroll-progress');
  if (progress) progress.setAttribute('aria-hidden', 'true');
  let scrollFrame = false;
  function updateViewport() {
    scrollFrame = false;
    const height = document.documentElement.scrollHeight - window.innerHeight;
    const fraction = height > 0 ? Math.min(1, Math.max(0, window.scrollY / height)) : 0;
    if (progress) progress.style.transform = `scaleX(${fraction})`;
    if (sticky && buyRow) {
      const bounds = buyRow.getBoundingClientRect();
      const headerBottom = Math.max(0, $('.site-header')?.getBoundingClientRect().bottom || 0);
      const passed = bounds.bottom <= headerBottom;
      sticky.hidden = !passed;
      sticky.classList.toggle('is-visible', passed);
    }
  }
  function requestViewportUpdate() {
    if (!scrollFrame) { scrollFrame = true; window.requestAnimationFrame(updateViewport); }
  }
  window.addEventListener('scroll', requestViewportUpdate, { passive: true });
  window.addEventListener('resize', requestViewportUpdate);
  window.addEventListener('load', requestViewportUpdate);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;

    requestViewportUpdate();
  });
  document.addEventListener('toggle', requestViewportUpdate, true);

  motion.addEventListener('change', () => {
    if (motion.matches) activeAnimations.forEach(animation => animation.cancel());
  });

  if ('IntersectionObserver' in window) {
    const revealSelector = '.section-head, .product-grid .product-card, .review-grid article, .journey-grid article, .feature-list article, .sensory-copy, .duo-copy, .campaign figure, .confidence-grid article, [data-reveal]';
    const rowDelay = element => {
      if (!element.parentElement) return 0;
      const top = element.getBoundingClientRect().top;
      const row = [...element.parentElement.children].filter(sibling => sibling.matches(revealSelector) && Math.abs(sibling.getBoundingClientRect().top - top) < 32);
      return Math.min(Math.max(0, row.indexOf(element)), 3) * 60;
    };
    const reveal = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        reveal.unobserve(entry.target);
        playAnimation(entry.target, [{ opacity: 0.72, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 560, delay: rowDelay(entry.target), easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards' });
      });
    }, { threshold: 0.13 });
    $$(revealSelector).forEach(element => reveal.observe(element));
  }



  $$('.gallery-prev').forEach(button => button.setAttribute('aria-label', 'Voir la photo précédente'));
  $$('.gallery-next').forEach(button => button.setAttribute('aria-label', 'Voir la photo suivante'));
  if (mainPhoto) updateGalleryDetails(mainPhoto.getAttribute('src'));
  updateViewport();
})();
